// extracted by mini-css-extract-plugin
export const splash = "contact-module--splash--19906";
export const content = "contact-module--content--3jvET";